/**
 * OrderListPresenter
 * --
 */
import { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ModalLayout,
  ShopInformationList,
} from 'components';
import { Empty, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import OrderFilter from './components/OrderFilter';
import OrderSummaryStatics from './components/OrderSummaryStatics';
import OrderDetail from './components/OrderDetail';
import OrderData from './components/OrderData';
// import ShopInformationList from './components/ShopInformationList';

/**----------------------------------------
 * [Component] 주문내역 - 프레젠터
 * ----------------------------------------
 */
const OrderListPresenter = ({
  permission,
  loading,
  orderList,
  searchFilter,
  handleChange,
  getOrders,
  onResetFilter,
  currentShop,
  setCurrentShop,
  onCancel,
  order_type,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isModalVisible, setIsModalVisible] = useState(null);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== VARIABLES ===== */
  // 결제완료 데이터
  const completedData = orderList.filter(
    (o) => o.payment_state === 'COMPLETED'
  );
  // 환불/취소 데이터
  const refundedData = orderList.filter(
    (o) => o.payment_state === 'PARTIALLY_REFUNDED'
  );
  const refundCount = refundedData.length ?? 0;
  const refundPrice = refundedData.reduce(
    (acc, cur) => acc + cur.final_price ?? 0,
    0
  );
  const totalCount = orderList.length ?? 0;
  const totalPrice =
    orderList.reduce((acc, cur) => acc + cur.final_price ?? 0, 0) ?? 0;
  const totalDiscount =
    completedData.reduce((acc, cur) => acc + cur.final_discount ?? 0, 0) ?? 0;

  /**
   *
   * --
   */
  const getTitle = () => {
    switch (order_type) {
      case 'PREPARING':
        return '상품 준비중';
      case 'ON_HOLD':
        return '배송보류';
      case 'SHIPPING':
        return '배송중';
      case 'DELIVERED':
        return '배송완료';
      case 'EXCHANGE_REQUESTED':
      case 'EXCHANGE_COMPLETED':
      case 'RETURN_REQUESTED':
      case 'RETURN_COMPLETED':
      case 'RETURN':
        return '취소/교환/반품/환불';
      default:
        return '주문 목록';
    }
  };

  /* ===== RENDER ===== */
  // console.log('[OrderListPresenter] orderList: ', orderList);

  return (
    <>
      <Spin spinning={loading} indicator={<LoadingOutlined spin />}>
        <Row>
          <Col x={24}>
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              backgroundColor={'none'}
            >
              <Title size={3} style={{ marginBottom: 10 }}>
                {getTitle()}
              </Title>
              {/* === 검색필터 컴포넌트=== */}
              <OrderFilter
                searchFilter={searchFilter}
                handleChange={handleChange}
                getOrders={getOrders}
                onResetFilter={onResetFilter}
              />
              {/* === 요약 === */}
              <OrderSummaryStatics
                totalCount={totalCount}
                totalPrice={totalPrice}
                totalDiscount={totalDiscount}
                refundPrice={refundPrice}
                refundCount={refundCount}
              />

              <Row style={{ minHeight: '50vh' }} className="boxShadow">
                {/* === 업체목록 === */}
                {permission === 'ADMIN' && (
                  <Col x={3}>
                    <ShopInformationList
                      onChange={setCurrentShop}
                      defaultChoose
                    />
                  </Col>
                )}
                {/* === Data === */}
                <Col
                  x={permission === 'ADMIN' ? 21 : 24}
                  style={{
                    borderLeft: '1px solid #EBEBEB',
                    backgroundColor: '#fff',
                  }}
                >
                  {currentShop ? (
                    <OrderData
                      orderList={orderList}
                      setIsModalVisible={setIsModalVisible}
                      type={order_type}
                      onReload={getOrders}
                    />
                  ) : (
                    <Empty
                      description="업체를 선택해주세요"
                      style={{ marginTop: 20 }}
                    />
                  )}
                </Col>
              </Row>

              {/* ===== 상세모달 ===== */}
              <ModalLayout
                type="drawer"
                maxWidth={800}
                isOpen={isModalVisible !== null}
                open={isModalVisible !== null}
                title="주문 상세보기"
                closable={true}
                onCancel={() => setIsModalVisible(null)}
              >
                {isModalVisible && (
                  <OrderDetail
                    orderId={isModalVisible.shop_order_id}
                    isModalVisible={isModalVisible}
                    onCancel={onCancel}
                    type={order_type}
                  />
                )}
                {/* <OrderDetail isModalVisible={isModalVisible} /> */}
              </ModalLayout>
            </Content>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
};

export default OrderListPresenter;
